import DateUtils from '../../../../services/DateUtils';

let eventId   = null;

export const EventService = {

	eventId: () => eventId,

    setEventId: (value = null) => { eventId = value },

	hasStarted: (event) => DateUtils.utcNow() > event.start_datetime_utc,

	hasEnded: (event) => DateUtils.utcNow() > event.end_datetime_utc,

	checkinIsEnabled: (event) => event.checkin_start !== null,

	checkinHasStarted: (event) => EventService.checkinIsEnabled(event) && event.checkin_started,

	checkinHasEnded: (event) => EventService.hasEnded(event),

	chatIsEnabled: (event) => !event.disable_video_chat

};

export default EventService;